import React from "react";
import PropTypes from "prop-types";

export const RegistrationReqIcon = (props) => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M16 21V19C16 16.7923 14.2077 15 12 15H6C3.79234 15 2 16.7923 2 19V21M19 8V14M22 11H16M5 7C5 9.20766 6.79234 11 9 11C11.2077 11 13 9.20766 13 7C13 4.79234 11.2077 3 9 3C6.79234 3 5 4.79234 5 7Z"
          stroke={props.selectedIcon ? "#448BCA" : "#6B778C"}
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

RegistrationReqIcon.propTypes = {
  selectedIcon: PropTypes.bool,
};
